import type {ActivesValuationItem} from "#app/domain/funnel/activesValuation";

export const CLIENT_VALUATIONS_CACHE_SEC = 900;

const getApiBaseUrl = (): string => {
    const explicitUrl = process.env.REACT_APP_API_URL;
    if (explicitUrl) {
        return explicitUrl.replace(/\/+$/, "");
    }
    if (typeof window !== "undefined" && window.location?.origin) {
        return window.location.origin.replace(/\/+$/, "");
    }
    return "";
};

const dataQueryKey = (field: string) => `data[${field}]`;

export const appendAggregateQueryParams = (
    params: URLSearchParams,
    payload: Record<string, any>
) => {
    Object.entries(payload).forEach(([key, value]) => {
        if (value == null) {
            return;
        }
        if (Array.isArray(value)) {
            const arrayKey = `${dataQueryKey(key)}[]`;
            value.forEach((item) => {
                if (item == null) {
                    return;
                }
                params.append(arrayKey, String(item));
            });
            return;
        }
        params.append(dataQueryKey(key), String(value));
    });

    if (!Object.prototype.hasOwnProperty.call(payload, "paginateType")) {
        params.append(dataQueryKey("paginateType"), "all");
    }
};

export function unwrapAggregateValuationRows(payload: any): ActivesValuationItem[] {
    let cur: any = payload;
    for (let depth = 0; depth < 6; depth++) {
        if (Array.isArray(cur)) {
            return cur as ActivesValuationItem[];
        }
        if (cur && typeof cur === "object" && "data" in (cur as object)) {
            cur = (cur as {data: any }).data;
            continue;
        }
        break;
    }
    return [];
}

export function buildUsersTodayValuationUrl(
    managerId: number,
    userIds?: number[]
): string {
    const baseUrl = getApiBaseUrl();
    if (!baseUrl) {
        throw new Error("API base URL is not configured");
    }
    const params = new URLSearchParams();
    const payload: Record<string, any> = {manager_id: managerId};
    if (userIds && userIds.length > 0) {
        payload.user_id = userIds;
    }
    appendAggregateQueryParams(params, payload);
    return `${baseUrl}/api/v1/call/aton-daily-valuation-aggregate/users_today_valuation?${params.toString()}`;
}

export function getAggregateAuthToken(): string {
    return typeof localStorage !== "undefined" ? (localStorage.getItem("api_token") || "") : "";
}

/** Сводная оценка по менеджеру (все user_id в scope, если `userIds` не передан). */
export async function fetchUsersTodayValuationAggregate(
    managerId: number,
    userIds?: number[]
): Promise<ActivesValuationItem[]> {
    const url = buildUsersTodayValuationUrl(managerId, userIds);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: getAggregateAuthToken(),
        },
    });
    const contentType = response.headers.get("content-type") ?? "";
    if (!contentType.includes("json")) {
        throw new Error(`Expected JSON from valuation API, got ${contentType || "unknown"}`);
    }
    const json = await response.json();
    if (!response.ok) {
        throw json;
    }
    const payload = Array.isArray(json) ? json : (json as {data?: any })?.data ?? json;
    return unwrapAggregateValuationRows(payload);
}
